import { createTheme } from "@mui/material/styles";

/**
 * MUI Theme Configuration
 * Inspired by specs/design/ reference app
 *
 * Note: This is a foundation theme. Further customization will be applied
 * based on the reference design once we analyze specs/design/ implementation.
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#C6222B",
      light: "#EF3F48",
      dark: "#87171A",
      contrastText: "#fff",
    },
    secondary: {
      main: "#35B3ED",
      light: "#6BC9F2",
      dark: "#1A8FC4",
      contrastText: "#fff",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  // Tablet-friendly spacing and touch targets
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 44, // Touch-friendly minimum
          padding: "12px 24px",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
        },
      },
    },
  },
});

export default theme;
